import {
  DropDown,
  ErrorsWings,
  TooltipWings,
  FilterWings,
  FilterSelectedItemWings,
  LongTextWings,
  FormRowWings,
  ChartCardWings,
  PieChart,
  LineChart,
  BarChart,
  ChartCardDashboardWings,
} from "wings-ui-components";
import { VueConstructor } from "vue/types";

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue: VueConstructor) {
    Vue.component("drop-down", DropDown);
    Vue.component("errors-wings", ErrorsWings);
    Vue.component("tooltip-wings", TooltipWings);
    Vue.component("filter-wings", FilterWings);
    Vue.component("filter-selected-item-wings", FilterSelectedItemWings);
    Vue.component("long-text-wings", LongTextWings);
    Vue.component("form-row-wings", FormRowWings);
    Vue.component("chart-card-wings", ChartCardWings);
    Vue.component("pie-chart", PieChart);
    Vue.component("line-chart", LineChart);
    Vue.component("bar-chart", BarChart);
    Vue.component("chart-card-dashboard-wings", ChartCardDashboardWings);
  },
};

export default GlobalComponents;
